import { render } from "./App.vue?vue&type=template&id=07d27f8d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=07d27f8d&lang=css"

import exportComponent from "/www/wwwroot/www.econg.net/vant_h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__